import PerformanceRow from "../models/PerformanceRow"
import Utils from "../portlibs/PortUtils";
import TableUtils from "../portlibs/TableUtils";
import GTable from "../libs/gtable/GTable";
import PortPref from "../portlibs/PortPref";
import PortUtils from "../portlibs/PortUtils";

export interface ISectorProps {
    cols:string[];
    rows:PerformanceRow[];
}
export default function SectorTable(props:ISectorProps){
    const {cols,rows} = props;

    const cell = (row:PerformanceRow, col:string) => row.value(col)
    const cellProp = (row:PerformanceRow, col:string) => ( {align:TableUtils.align(col),className:PortUtils.cellClass(col, (row as any)[col])} )
    const header = (col:string) => Utils.label(col)
    const headerProps = (col:string) => ({align:TableUtils.align(col)})
    const rowKey = (row:PerformanceRow) => row.sector?.toString() || "Unknown"
    return <GTable tableName="sectors" userPref={PortPref.i} rows={rows} cols={cols} rowKey={rowKey} bodyCell={cell} bodyCellProps={cellProp} headerCell={header} headerCellProps={headerProps}/>
}